import { A } from "@solidjs/router"
import { Component, Show } from "solid-js"
import { Img } from "./universal/image";
import { ArtworkItem, NewImage } from "../Types";
import { Exhibiting } from "./exhibiting";
import { RawHtml } from "./raw-html";
import { slug } from "../library/common";
import { P } from "./p";

type Award = {
    Id: number;
    Name: string;
}
type SalonSubmission = {
    Id: string;
    SalonSubmissionId: string;
    Artist: string;
    SalonEntrantId: string;
    IsHighSchoolStudent: boolean;
    IsExhibitingAtSalmagundi: boolean;
    IsExhibitingAtMEAM: boolean;
    IsExhibiting: boolean;
    Year: string;
    Medium: string;
    Measurements: string;
    Awards: Award[];
    Prizes: SalonPrize[];
    SaleStatus: string;
    Image: NewImage;
    PurchaseAwardPaidPrice: string;
    Title: string;
    Instructors: string;
    StudentAge: string;
    EntrantAge: string;
    School: string;
    HighSchoolInstructors: string;
};
type SalonPrize = {
    PrizeAmount: number;
    AwardId: number;
}
type Props = {
    item: SalonSubmission;
    maxHeight: number;
    maxWidth: number;
}
export const Winner : Component<Props> = ({ item, maxHeight, maxWidth }) => {
    const award = item.Awards[0];
    const prize = item.Prizes.find(x => x.AwardId == award.Id);
    const artworkUrl = `/artwork/by-category/${slug(item.Title)}/${slug(item.Artist)}/${item.SalonSubmissionId}`;
    const artistUrl = `/artist/${slug(item.Artist)}/${item.SalonEntrantId}`;
    return (
        <div class="winner">
            <div class="row">
                <div class="col-md-6">
                    <div class="pull-right" style={{ "background-color": item.Image.DominantColourHexCode || "#333", "max-width": `${maxWidth}px` }}>
                        <A href={artworkUrl}>
                            <Img class="no-clicky-for-you" src={item.Image.URL}
                                maxHeight={maxHeight} maxWidth={maxWidth}
                                naturalWidth={item.Image.Width} naturalHeight={item.Image.Height}
                                mode="max" />
                        </A>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="grid-item" style="width: 100%; max-width: none;">
                        <div class="didactic">
                            <div class="row">
                                <div class="col-md-12">
                                    <Show when={!!prize}>
                                        <h3 class="purchase-price">
                                            ${prize!.PrizeAmount} Cash Award
                                        </h3>
                                    </Show>
                                    <h3 class="award">
                                        {award.Name}
                                    </h3>
                                    <h1 style="font-size: 3em;">
                                        <A href={artistUrl}>{item.Artist}</A>
                                    </h1>
                                    <h2>
                                        <A href={artworkUrl}>{item.Title}</A>
                                    </h2>
                                    <P when={item.Year}>{item.Year}</P>
                                    <P when={item.Medium}>{item.Medium}</P>
                                    <RawHtml value={item.Measurements} />
                                    <Show when={item.IsHighSchoolStudent}>
                                        <>
                                            <hr />
                                            <Show when={item.Instructors || item.HighSchoolInstructors}>
                                                <p>
                                                    <b>Taught by:</b> {item.Instructors || item.HighSchoolInstructors}
                                                </p>
                                            </Show>
                                            <Show when={item.School}>
                                                <p>
                                                    <b>Studied at:</b> {item.School}
                                                </p>
                                            </Show>
                                            <Show when={item.StudentAge || item.EntrantAge}>
                                                <p>
                                                    <b>Created by the student at {item.StudentAge || item.EntrantAge} years old</b>
                                                </p>
                                            </Show>
                                        </>
                                    </Show>
                                    <Exhibiting artwork={{
                                        IsExhibitingAtMEAM: item.IsExhibitingAtMEAM,
                                        IsExhibitingAtSalmagundi: item.IsExhibitingAtSalmagundi,
                                        IsForSale: item.SaleStatus == "ForSale",
                                        PurchaseAwardPaidPrice: item.PurchaseAwardPaidPrice,
                                        MEAMPurchase: item.Awards.some(x => x.Name.indexOf("MEAM") >= 0),
                                        IsExhibiting: item.IsExhibiting
                                    } as ArtworkItem} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}